<template>
  <div class="login-container">
    <!-- <van-nav-bar
      class="app-nav-bar"
      title="移动权益"
      left-arrow
      @click-left="$router.back()"
    /> -->
    <!-- 登录表单 -->
    <div class="login-form-wrapper">
      <div class="login-header">
        <img class="login-logo" src="../../assets/huiy/member.png" alt="移动权益">
        <h2>移动权益&美年大健康</h2>
        <p>请登录后查看健康体检产品</p>
      </div>
      
      <van-form 
        :show-error="false"
        :show-error-message="false"
        ref="login-form"
        @submit="onLogin"
        @failed="onFailed"
        >
        <van-field
          v-model="user.mobile"
          clearable
          icon-prefix="toutiao"
          name="mobile"
          left-icon="shouji"
          placeholder="请输入手机号"
          :rules="formRules.mobile"
        />
        <van-field
          v-model="user.code"
          clearable
          center
          icon-prefix="toutiao"
          name="code"
          left-icon="yanzhengma"
          placeholder="请输入验证码"
          :rules="formRules.code"
        >
          <template #button>
            <van-count-down 
              v-if="isCountDownShow"
              :time="1000 * 60" 
              format="ss s"
              @finish="isCountDownShow = false"
            />
            <van-button 
              v-else
              size="small" 
              round
              center
              class="send-btn"
              :loading="isSendSmsLoading"
              @click.prevent="onSendSms"
            >发送验证码</van-button>
          </template>
        </van-field>
        <div class="login-btn-wrap">
          <van-button type="info" block class="login-btn" native-type="submit">登录</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { login, sendSms, getOauth2AccessTokenNew } from '@/api/user'
import { Toast } from 'vant'
import { setItem } from '@/utils/storage'
import { getWechatCode, isWXBrowser } from '@/api/getcode.js'

export default {
  name: 'HealthLogin',
  components: {},
  props: {},
  data () {
    return {
      isCountDownShow: false,
      isSendSmsLoading: false,
      user: {
        mobile: '',
        code: ''
      },
      formRules: {
        mobile: [
          { required: true, message: '请输入手机号' },
          { pattern: /^1[3|5|7|8|9]\d{9}$/, message: '手机号格式错误' },
        ],
        code: [
          { required: true, message: '请输入验证码' },
          { pattern: /^\d{6}$/, message: '验证码格式错误' },
        ], 
      }
    }
  },
  computed: {},
  watch: {},
  created () {},
  async mounted () {
    // 在登录页面统一处理微信openid获取
    if (isWXBrowser) {
      await this.handleWechatAuth();
    }
  },
  methods: {
    async onLogin() {
      Toast.loading({
        message: '登录中...',
        forbidClick: true,
        duration: 0
      });
      
      try {
        // 调用后端登录接口
        const { data } = await login(this.user)
        
        if (data.code === 200 && data.data && data.data.success) {
          Toast.success('登录成功')

          // 构建用户数据
          const userData = {
            token: data.data.accessToken,
            userId: data.data.userId,
            mobile: data.data.mobile,
            userName: '美年用户'
          }
          
          // 将用户状态放到Vuex容器中
          this.$store.dispatch("AddUser", userData)

          // 保存手机号
          setItem("mobile", this.user.mobile)

          // 清除 layout 的缓存，让它重新渲染
          this.$store.commit('removeCachePage', 'LayoutIndex')

          // 登录成功后跳转到目标页面
          const targetPage = this.$route.query.redirect || '/index/health';
          this.$router.push(targetPage)
        } else {
          Toast.fail(data.data?.message || '登录失败')
        }
      } catch(err) {
        console.error('登录失败:', err)
        Toast.fail('登录失败，请检查手机号码和验证码');
      }
    },
    
    async onSendSms() {
      try {
        // 1. 校验手机号
        await this.$refs['login-form'].validate('mobile')
        
        // 2. 请求发送验证码
        this.isSendSmsLoading = true
        const { data } = await sendSms(this.user.mobile)
        
        if (data.code === 200 && data.data && data.data.success) {
          // 3. 显示倒计时
          this.isCountDownShow = true
          Toast('验证码发送成功')
        } else {
          Toast.fail(data.data?.message || '验证码发送失败')
        }
      } catch (err) {
        console.error('发送验证码失败:', err)
        
        if (err && err.response && err.response.status === 429) {
          Toast('请求过于频繁，请稍后重试')
        } else if (err.name === 'mobile') {
          // 表单验证失败
          Toast(err.message)
        } else {
          Toast('发送失败，请稍后重试')
        }
      } finally {
        this.isSendSmsLoading = false
      }
    },
    
    onFailed(error) {
      if (error.errors[0]) {
        Toast(error.errors[0].message)
      }
    },
    
    // 处理微信授权和openid获取
    async handleWechatAuth() {
      try {
        // 检查是否已有openid
        const storedOpenId = localStorage.getItem('openId');
        if (storedOpenId) {
          console.log('已有openId，无需重新获取:', storedOpenId.substring(0, 6) + '***');
          return;
        }
        
        // 获取微信授权code
        const code = getWechatCode();
        if (!code) {
          console.log('正在跳转微信授权...');
          return; // getWechatCode内部已处理授权跳转
        }
        
        console.log('获取到微信code，开始获取openId:', code);
        
        // 调用接口获取openId
        const { data } = await getOauth2AccessTokenNew({ code });
        
        if (data.code === 0 && data.data) {
          localStorage.setItem('openId', data.data);
          console.log('openId获取成功:', data.data.substring(0, 6) + '***');
          // Toast.success('微信授权成功');
        } else {
          console.error('获取openId失败:', data);
          Toast.fail('微信授权失败: ' + (data.msg || '未知错误'));
        }
        
      } catch (error) {
        console.error('微信授权异常:', error);
        Toast.fail('微信授权异常，请重试');
      }
    }
  }
}
</script>

<style scoped lang="less">
.login-container {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.login-form-wrapper {
  padding: 20px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
  padding-top: 20px;
}

.login-logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-bottom: 15px;
}

.login-header h2 {
  font-size: 20px;
  color: #333;
  margin-bottom: 10px;
}

.login-header p {
  font-size: 14px;
  color: #999;
}

.login-btn-wrap {
  margin: 30px 0;
}

.login-btn {
  background-color: #E60027;
  border-color: #E60027;
  border-radius: 4px;
  height: 44px;
}

.send-btn {
  background-color: #E60027;
  border-color: #E60027;
  color: #fff;
  font-size: 12px;
}
</style>